<template>
  <div
    :id="id"
    class="video-section">
    <video
      :id="getVideoId()"
      playsinline="true"
      ref="video"
      loop
      controls
      preload="auto"
      :src="getVideoUrl()"
      :poster="require(`@/assets/${content.poster}`)"
      class="video"
      style="object-fit: cover; object-position: 50% 50%;" />
  </div>
</template>
<script>

import VueScrollTo from 'vue-scrollto'
import { trackSection } from '../utils/track.js'

export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      scrollTimeout: null,
      videoTimeout: null,
      isPlaying: false,
      hasBeenFixed: false,
      tracked: false
    }
  },
  mounted () {
    this.startVideo()
    window.addEventListener('scroll', () => {
      clearTimeout(this.videoTimeout)
      this.videoTimeout = setTimeout(() => {
        this.startVideo()
      }, 300)

      clearTimeout(this.scrollTimeout)
      if (!this.hasBeenFixed) {
        this.scrollTimeout = setTimeout(() => {
          this.setPosition()
        }, 100)
      }

      this.checkTracker()
    })
  },
  methods: {
    startVideo () {
      const vid = document.getElementById(this.getVideoId())
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.isPlaying) {
          vid.play()
          this.isPlaying = true
        }
      } else {
        if (this.isPlaying) {
          vid.pause()
          this.isPlaying = false
        }
      }
    },
    setPosition () {
      if (this.$el.classList.contains('in-viewport')) {
        VueScrollTo.scrollTo(this.$el, 500)
        this.hasBeenFixed = true
      }
    },
    getVideoId () {
      return `${this.id}-video`
    },
    getVideoUrl () {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/${this.content.video}`)
    },
    checkTracker () {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true
          trackSection(this.tracking.trackingId)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .video-section {
    height: 100vh;
    max-width: 600px;
    margin: auto auto;
    overflow: hidden;
    z-index: 10;
  }

  .video {
    width: 100%;
    max-width: 600px;
    height: 100%;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/sections/VideoSection.vue